import clsx from 'clsx';
import { Box, SxProps, Theme } from '@mui/material';

const TickerRowAnimation = ({
  children,
  animateLeftToRight,
  animateRightToLeft,
  sx,
}: {
  children: JSX.Element[];
  animateLeftToRight?: boolean;
  animateRightToLeft?: boolean;
  sx?: SxProps<Theme>;
}) => {
  return (
    <Box
      sx={[
        {
          position: 'relative',
          height: '80px',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          width: { xs: '600px', sm: '900px', md: '1200px', lg: '1600px', xl: '2000px' },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}>
      <Box
        className={clsx({ animateLeftToRight, animateRightToLeft })}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          position: 'absolute',
          overflow: 'hidden',
          '&.animateLeftToRight': {
            left: '0px',
            animation: 'animateLeftToRight linear infinite',
            animationDuration: '60s',
            '@keyframes animateLeftToRight': {
              '0%': { transform: 'translateX(0) translateZ(0)' },
              '100%': { transform: 'translateX(-50%) translateZ(0)' },
            },
          },
          '&.animateRightToLeft': {
            right: '0px',
            animation: 'animateRightToLeft linear infinite',
            animationDuration: '60s',
            '@keyframes animateRightToLeft': {
              '0%': { transform: 'translateX(0) translateZ(0)' },
              '100%': { transform: 'translateX(50%) translateZ(0)' },
            },
          },
        }}>
        {children}
      </Box>
    </Box>
  );
};

export default TickerRowAnimation;
